<ng-container *ngIf="navDataService.appReady">
  <!-- <app-loader [hidden]="navDataService.httpRequestDetails.number === 0" class="w-100 h-100"></app-loader> -->
  <app-notification-bar class="fixed-top"></app-notification-bar>
  <div class="h-100 hide-in-trasparent">
    <app-logged-layout *ngIf="!rolesService.userHasRole(); else not_logged_layout"></app-logged-layout>
    <ng-template #not_logged_layout>
      <app-not-logged-layout></app-not-logged-layout>
    </ng-template>
  </div>
  <loader-with-words></loader-with-words>
</ng-container>
<canvas id="canvas-to-resize" class="d-none"></canvas>
